import API_BASE_URL from './config'; 
import React, { useState } from 'react';

function SkillsGuide() {
  const [expandedSkill, setExpandedSkill] = useState(null);

  const skillsGuide = [
    {
      name: 'Animal Husbandry',
      levels: [
        {
          level: 1,
          title: 'Dog Walker',
          xp: 50,
          requirements: ['Comfy Walking Shoes'],
          salary: 100,
          bonus: 'Small boost to IP earned from adventures that feature this staff'
        },
        {
          level: 2,
          title: 'Pet Sitter',
          xp: 250,
          requirements: ['Overnight Essentials Bag'],
          salary: 250,
          bonus: 'Medium boost to IP earned from adventures that feature this staff'
        },
        {
          level: 3,
          title: 'Kennel Attendant',
          xp: 500,
          requirements: ['Work Apron'],
          salary: 1000,
          bonus: 'Large boost to IP earned from adventures that feature this staff'
        },
        {
          level: 4,
          title: 'Kennel Manager',
          xp: 1000,
          requirements: ['Manager’s Clipboard'],
          salary: 1000,
          bonus: 'Large boost to IP earned from adventures that feature this staff, chance to double the IP earned'
        },
        {
          level: 5,
          title: 'Kennel Owner',
          xp: 2000,
          requirements: ['Kennel Master Keys'],
          salary: 2000,
          bonus: 'Large boost to IP earned from adventures that feature this staff, chance to double the IP earned, reduced prices in the Item Shop'
        }
      ],
      comboBonuses: [
        {
          requiredSkills: ['Kennel Owner (Animal Husbandry)', 'Veterinarian (Animal Medicine)'],
          bonus: 'Kennel Health Expert: Injury chance reduction'
        }
      ]
    },
    {
      name: 'Dog Grooming',
      levels: [
        {
          level: 1,
          title: 'Bather',
          xp: 100,
          requirements: ['Waterproof Smock'],
          salary: 600,
          bonus: 'Small bonus towards iCON Effort Score'
        },
        {
          level: 2,
          title: 'Apprentice Groomer',
          xp: 250,
          requirements: ['Basic Brush Set'],
          salary: 1200,
          bonus: 'Medium bonus to iCON Effort Score'
        },
        {
          level: 3,
          title: 'Professional Pet Groomer',
          xp: 500,
          requirements: ['High Quality Grooming Shears'],
          salary: 2400,
          bonus: 'Large bonus to iCON Effort Scores'
        },
        {
          level: 4,
          title: 'Master Dog Groomer',
          xp: 1000,
          requirements: ['Hydraulic Grooming Table'],
          salary: 4800,
          bonus: 'Large bonus to iCON Effort Scores, reduced cost of Grooming Appointments (hair edit item)'
        },
        {
          level: 5,
          title: 'Conformation Ring Grooming Specialist',
          xp: 2000,
          requirements: ['Ringside Groomer’s Box'],
          salary: 9600,
          bonus: 'Large bonus to iCON Effort Scores, FREE Grooming Appointments (hair edit item)'
        }
      ],
      comboBonuses: []
    },
    {
      name: 'Animal Medicine',
      levels: [
        {
          level: 1,
          title: 'Animal Science Major',
          xp: 100,
          requirements: ['Biology 181 Study Guide'],
          salary: 0,
          bonus: '+10 HP to any dog that has a relationship with this staff'
        },
        {
          level: 2,
          title: 'Veterinary Technician',
          xp: 300,
          requirements: ['Veterinary Technician’s Textbook', '25,000 DFG$'],
          salary: 4000,
          bonus: '+25 HP to any dog that has a relationship with this staff'
        },
        {
          level: 3,
          title: 'Veterinary Technologist',
          xp: 600,
          requirements: ['Tattered University Hoodie', '50,000 DFG$'],
          salary: 8000,
          bonus: '+50 HP to any dog that has a relationship with this staff'
        },
        {
          level: 4,
          title: 'Veterinarian',
          xp: 1200,
          requirements: ['Embroidered Lab Coat', '100,000 DFG$', 'Doctor’s Coat (2000 DFG$)'],
          salary: 16000,
          bonus: '+50 HP to any dog that has a relationship with this staff, reduced cost health testing'
        },
        {
          level: 5,
          title: 'Veterinary Specialist',
          xp: 2000,
          requirements: ['Handwritten Thank-You Note', '250,000 DFG$'],
          salary: 32000,
          bonus: '+50 HP to any dog that has a relationship with this staff, free health testing'
        }
      ],
      comboBonuses: [
        {
          requiredSkills: ['Kennel Owner (Animal Husbandry)', 'Veterinarian (Animal Medicine)'],
          bonus: 'Kennel Health Expert: Injury chance reduction'
        }
      ]
    },
    {
      name: 'Canine Evaluation',
      levels: [
        {
          level: 1,
          title: 'Junior Competitor',
          xp: 50,
          requirements: ['Well Loved Stuffed Dog'],
          salary: 500,
          bonus: 'Reduced iCON RNG entry fee'
        },
        {
          level: 2,
          title: 'Novice Handler',
          xp: 150,
          requirements: ['Illustrated Breed Standard Book'],
          salary: 1000,
          bonus: 'Free iCON RNG entry fee'
        },
        {
          level: 3,
          title: 'Professional Handler',
          xp: 300,
          requirements: ['Favorite Show Lead'],
          salary: 10000,
          bonus: 'Free iCON RNG entry fee, reduced iCON Effort entry fee'
        },
        {
          level: 4,
          title: 'Certified Judge',
          xp: 500,
          requirements: ['Canine Anatomy Study Guide'],
          salary: 15000,
          bonus: 'Included in iCON Effort Judge’s List, free iCON RNG and Effort entry fees'
        },
        {
          level: 5,
          title: 'Renowned Judge',
          xp: 1000,
          requirements: ['Judge’s Pin'],
          salary: 20000,
          bonus: 'Included in iCON Effort Judge’s List, free iCON RNG and Effort entry fees, can host independent shows through the event center (coming soon)'
        }
      ],
      comboBonuses: []
    }
  ];

  const toggleSkill = (skillName) => {
    setExpandedSkill(expandedSkill === skillName ? null : skillName);
  };

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '60px 20px', textAlign: 'left' }}>
      <h1 style={{ color: '#1E88E5', fontSize: '2em', marginBottom: '20px', textAlign: 'center' }}>
        Skills Guide
      </h1>
      <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px', textAlign: 'center' }}>
        Skills are specially formulated quests-lines for Registered Staff. All Registered staff can participate in the skills program by completing the prompt art for your level and submitting it for admin review. <p> Skills allow players to earn gameplay currency and additional bonuses by earning and leveling skills. There are four skills, each one has five levels, and the bonuses improve progressively. </p> A single staff member may earn all the available skills, but may only choose up to 2 skills as hobbies and 1 skill as a profession. Profession salaries can be collected once per day by staff who have earned that skill and have it assigned as a profession in their profile.
      </p>

      {skillsGuide.map((skill) => (
        <div
          key={skill.name}
          style={{
            backgroundColor: '#f9f9f9',
            borderRadius: '8px',
            marginBottom: '15px',
            boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
            border: '1px solid #E6F0FA'
          }}
        >
          <div
            style={{
              padding: '15px',
              cursor: 'pointer',
              backgroundColor: expandedSkill === skill.name ? '#E6F0FA' : '#f9f9f9',
              borderRadius: '8px 8px 0 0',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
            onClick={() => toggleSkill(skill.name)}
          >
            <h2 style={{ color: '#4CAF50', fontSize: '1.5em', margin: 0 }}>{skill.name}</h2>
            <span style={{ color: '#1E88E5', fontSize: '1.2em' }}>
              {expandedSkill === skill.name ? '−' : '+'}
            </span>
          </div>

          {expandedSkill === skill.name && (
            <div style={{ padding: '15px' }}>
              <h3 style={{ color: '#1E88E5', fontSize: '1.2em', marginBottom: '10px' }}>Levels</h3>
              {skill.levels.map((level) => (
                <div
                  key={level.level}
                  style={{
                    padding: '10px',
                    backgroundColor: '#fff',
                    borderRadius: '5px',
                    marginBottom: '10px',
                    border: '1px solid #E6F0FA'
                  }}
                >
                  <h4 style={{ color: '#333', fontSize: '1.1em', margin: '0 0 5px' }}>
                    {level.title} (Level {level.level})
                  </h4>
                  <p style={{ color: '#333', fontSize: '14px', margin: '5px 0' }}>
                    <strong>XP:</strong> {level.xp}
                  </p>
                  <p style={{ color: '#333', fontSize: '14px', margin: '5px 0' }}>
                    <strong>Requirements:</strong> {level.requirements.join(', ')}
                  </p>
                  <p style={{ color: '#333', fontSize: '14px', margin: '5px 0' }}>
                    <strong>Salary:</strong> {level.salary} DFG$
                  </p>
                  <p style={{ color: '#333', fontSize: '14px', margin: '5px 0' }}>
                    <strong>Bonus:</strong> {level.bonus}
                  </p>
                </div>
              ))}

              {skill.comboBonuses.length > 0 && (
                <>
                  <h3 style={{ color: '#1E88E5', fontSize: '1.2em', margin: '15px 0 10px' }}>
                    Combo Bonuses
                  </h3>
                  {skill.comboBonuses.map((combo, index) => (
                    <div
                      key={index}
                      style={{
                        padding: '10px',
                        backgroundColor: '#fff',
                        borderRadius: '5px',
                        marginBottom: '10px',
                        border: '1px solid #E6F0FA'
                      }}
                    >
                      <p style={{ color: '#333', fontSize: '14px', margin: '5px 0' }}>
                        <strong>Requirements:</strong> {combo.requiredSkills.join(' + ')}
                      </p>
                      <p style={{ color: '#333', fontSize: '14px', margin: '5px 0' }}>
                        <strong>Bonus:</strong> {combo.bonus}
                      </p>
                    </div>
                  ))}
                </>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default SkillsGuide;